import exponent from "./exponent";

export default function(step, max) {
  step = Math.abs(step), max = Math.abs(max) - step;
  return Math.max(0, exponent(max) - exponent(step)) + 1;
}



//////////////////
// WEBPACK FOOTER
// /Users/sharvil/Desktop/fall17/adaptive/assign1/~/d3-format/src/precisionRound.js
// module id = ../../../../d3-format/src/precisionRound.js
// module chunks = 3